module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Vip-38cd4daf966769317d2f2b9bf4cd8321.svg";